import { UserManagmentService } from './../user-managment.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { User } from './../user-managment.model';
import { EncryptionProviderService } from '@shared/encryption.service';
import { ToastrService } from 'ngx-toastr';
import { ErrorHandler } from '../../../utils/error-handler.service';
import { NgForm} from '@angular/forms';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
  providers: [UserManagmentService],
})
export class AddUserComponent implements OnInit {
  @ViewChild('f', { static: false }) form: NgForm;

  hide = true;

  regionList: [];

  roleList: [];

  departmentList: [];

  userList: User[] = [];

  user = new User();

  constructor(
    public userManagmentService: UserManagmentService,
    public encryptionProviderService: EncryptionProviderService,
    private toastr: ToastrService,
    private errorHandler: ErrorHandler
  ) { }

  ngOnInit() {
    this.readUser();
    this.getDepartmentList();
    this.getRegionList();
    this.getRoleList();
  }

  resetForm(){
    this.form.resetForm();
    this.user = new User();
  }

  public processCreateData() {
    const user = JSON.parse(JSON.stringify( this.user));
    if(user.id){
      user.opType = 1;
    }else{
      user.opType = 2;
      user.id = 0;
    }
    user.password = this.encryptionProviderService.encryptData(this.user.password);
    this.userManagmentService.createOrUpdateUser(user).subscribe(
      (response) => {
        if (response.status === 0) {
          this.toastr.success(response.message);
          this.readUser();
          this.resetForm();
        } else {
          this.user.password = this.encryptionProviderService.decryptData(this.user.password);
          this.toastr.error(response.error.errorMessage);
        }
      },
      (error) => {
        this.user.password = this.encryptionProviderService.decryptData(this.user.password);
        this.toastr.error(error.errorMessage);
      }
    );
  }

  public readUser() {
    const obj = {};
    this.userManagmentService.readUsers(obj).subscribe(
      (response) => {
        this.userList = response.data.list;
      },
      (error) => { }
    );
  }


  getDepartmentList = () => {
    this.userManagmentService.getDeparmentList().subscribe((response) => {
      if (response.status === 0) {
        this.departmentList = response.data.list;
      }
      else {
        this.errorHandler.handleError(response);
      }
    },
      (error) => {
        this.errorHandler.handleError(error);
      })
  }

  getRegionList = () => {
    this.userManagmentService.getRegionList().subscribe((response) => {
      if (response.status === 0) {
        this.regionList = response.data.list;
      }
      else {
        this.errorHandler.handleError(response);
      }
    },
      (error) => {
        this.errorHandler.handleError(error);
      })
  }

  getRoleList = () => {
    let obj = {}
    this.userManagmentService.getRoleList(obj).subscribe((response) => {
      if (response.status === 0) {
          if(response.data){
            this.roleList = response.data.list;
          }
      }
      else {
        this.errorHandler.handleError(response);
      }
    },
      (error) => {
        this.errorHandler.handleError(error);
      })
  }

  public onEdit(data) {
    this.user = data;
    if(data.isUser){
      this.user.userType = 2;
    }else{
      this.user.userType = 1;
    }
    
    this.user.password = this.encryptionProviderService.decryptData(this.user.password);
  }

  /**
   * 
   * Phone validation
   */
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

   /***
   * Name position validation
   */
  keyPressAlpha(event: any) {
    const pattern = /[a-zA-Z0-9 ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
